import styled from "styled-components";

export const PageContent = styled.div`
  padding: ${({ theme }) => theme.space[4]};
  max-width: 960px;
  margin: 0 auto;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${({ theme }) => `${theme.space[10]} ${theme.space[6]}`};
`;

export const EmptyIcon = styled.div`
  color: ${({ theme }) => theme.colors.gray300};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const EmptyTitle = styled.h2`
  font-size: ${({ theme }) => theme.fonts.md};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray600};
  margin: 0 0 ${({ theme }) => theme.space[2]} 0;
`;

export const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray400};
  max-width: 280px;
  margin: 0 auto;
  line-height: 1.5;
`;
